import { switchMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { MessageService } from '../../../core/service/message.service';
import { ContactService } from '../data/contact.service';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { CommandBase, Command } from '../../../core/model/command';
import { Observable } from 'rxjs';
import { tenantCommand } from '../../model/const/command';

@Injectable()
export class CleanupTenantCommandHandler implements ICommandHandler {
  constructor(
    private _dataService: ContactService,
    private _messageService: MessageService
  ) {}

  canExecute(command: CommandBase): boolean {
    return command.id === tenantCommand.cleanupData;
  }

  execute(command: CommandBase): Observable<void> {
    return this._messageService.showDialog('TENANT.MESSAGE.CLEANUP_DATA').pipe(
      switchMap(result => {
        if (result) {
          return this._dataService.cleanupData((<Command>command).context.id);
        }
      })
    );
  }
}
